module.exports = __webpack_public_path__ + "img/b8e4afce851e1ec2f30a55279a51579b.png";